module.exports = __webpack_public_path__ + "media/lesson/fonts/Frutiger/FrutigerLight-c813c6cf4320f0419c3c4fe261f38ebf.eot";